
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/reporting-illegal-content",
      function () {
        return require("private-next-pages/[lang]/legal/reporting-illegal-content/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/reporting-illegal-content"])
      });
    }
  